import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <g>
        <path fill={colourFill} d="M40.07 18.13 44.36 20l-1.09-4.89a39.21 39.21 0 0 1-3.2 3Z" />
        <path
          fill={colourFill}
          d="M37.63 20.05a47.6 47.6 0 0 0 16.16 4.16 22.59 22.59 0 0 0-9.3-10.41l1.94 8.73-7.65-3.36c-.38.3-.76.6-1.15.88ZM52.08 25.53a44.5 44.5 0 0 1-4.69-.73l2 5.15ZM38.42 26.88l3.3-3.67c-1.44-.49-2.83-1-4.17-1.6Z"
        />
        <path
          fill={colourFill}
          d="m56.16 57.45-.3-23.08a24.9 24.9 0 0 0-1.55-8.69l-.68-.06-4.74 7.69-3.4-9c-.83-.21-1.64-.45-2.44-.69l-5.85 6.5-1.48-9c-1 .67-2 1.29-3 1.87l-.2 9.65-7.36-6c-1.36.54-2.69 1-4 1.44l-2.84 9.75-5.27-7.33a24.43 24.43 0 0 0-.3 3.86v23.09H15V53h13.2v-7.66c-1.6-2.36-3.2-5-3.2-7.22a5.12 5.12 0 0 1 9.5-2.65 5.13 5.13 0 0 1 9.5 2.65c0 2.12-1.5 4.69-3.3 7v8.66H54v3.68Z"
        />
        <path
          fill={colourFill}
          d="M38.89 34.47a3.65 3.65 0 0 0-3.65 3.65.74.74 0 1 1-1.47 0 3.65 3.65 0 1 0-7.29 0c0 3.47 5.4 9.16 8 11.58 2.63-2.42 8-8.11 8-11.58a3.66 3.66 0 0 0-3.65-3.65ZM11.28 58.92H3.93v7.35H65v-7.35h-7.37"
        />
        <path
          fill={colourFill}
          d="M34.36 51.41a.75.75 0 0 1-.5-.18 54.73 54.73 0 0 1-4.19-4.13V53h9.57v-6.11a50.49 50.49 0 0 1-4.38 4.34.77.77 0 0 1-.5.18ZM29.14 54.5H16.43v2.94h36.05v-3H40M19.89 28.58c-1.8.54-3.47 1-5 1.31l3.25 4.5ZM22.05 10.52c.53.43 1.31 1.05 2.31 1.79a21.26 21.26 0 0 1 19.78-.37c.57-.69 1.1-1.41 1.63-2.16a25 25 0 0 0-23.72.74ZM47.07 10.48c-.52.75-1.06 1.48-1.62 2.17a24.22 24.22 0 0 1 10 11.61c1 0 1.93 0 2.91-.08a25.23 25.23 0 0 0-11.26-13.7ZM12.34 28.93A24.7 24.7 0 0 1 23 13.12c-1-.78-1.81-1.41-2.25-1.79a25.11 25.11 0 0 0-11 18c.66-.09 1.56-.24 2.63-.45ZM11.28 34.3a21.23 21.23 0 0 1 .55-3.75c-1.05.2-1.65.25-2.25.33-.3 0-.49.06-.51 1.32v25.25h2.21Z"
        />
        <path
          fill={colourFill}
          d="M13.85 28.62a63.43 63.43 0 0 0 20.76-8.33q-1-.46-1.89-1L26 24.72l-.14-9.52-1.66-1.14a23 23 0 0 0-10.35 14.56Z"
        />
        <path
          fill={colourFill}
          d="M31.45 18.57a92.1 92.1 0 0 1-4-2.39l.08 5.52ZM25.69 13.27a70.22 70.22 0 0 0 10.39 6.08 40.67 40.67 0 0 0 7.06-6.25 19.82 19.82 0 0 0-17.45.17ZM31.51 23.87c-1.5.78-3 1.49-4.46 2.11l4.34 3.56ZM57.55 57.55l2.28-.1V32.2a35.76 35.76 0 0 0-1.07-6.57c-.93.07-1.85.11-2.76.19.66 2.75 1.45 4.78 1.46 8.63Z"
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
